const processCustomProgram = (item) => {
	const program = {};
	// TODO: Some program ID is empty
	program.id = item.program.id ? parseInt(item.program.id, 10) : null;
	program.nbaId = item.nbaId ? parseInt(item.nbaId, 10) : null;
	program.name = item.program.title;
	program.description = item.program.description;
	program.customImage = item.image ? `${item.image}?w=480&h=270` : '';
	program.runtimeHours = item.program.runtimeHours;
	program.seoName = item.program.seoName;
	if (item.entitlements && item.entitlements !== 'free' && item.entitlements !== '') {
		// TODO: NBA Feed only return entitlements : 'league-pass', 'league-pass-premium', 'nba-tv'
		// We do NOT know which program purchase it belong to
		// There are 4 Purchase: FREE(undefined), VAULT (1), PREMIUM (3), SUBSCRIBER (4))
		if (item.entitlements === 'leaguepass' || item.entitlements === 'league-pass') {
			program.purchaseTypeId = 4;
		} else if (item.entitlements === 'league-pass-premium') {
			program.purchaseTypeId = 3;
		} else if (item.entitlements === 'nbatv' || item.entitlements === 'nba-tv') {
			program.purchaseTypeId = 'nbatv';
		}
	}
	program.itemType = 'program';
	return program;
};
const processCustomNBAGameVideo = (item) => {
	const program = {};
	// TODO: Some program ID is empty
	program.id = item.endeavorId ? parseInt(item.endeavorId, 10) : null;
	program.nbaId = item.id ? parseInt(item.id, 10) : null;
	program.name = item.title;
	program.description = item.excerpt;
	program.customImage = item.featuredImage ? `${item.featuredImage}?w=480&h=270` : '';
	program.runtimeHours = item.videoDuration;
	program.seoName = item.endeavorSeoName;
	if (item.entitlements && item.entitlements !== 'free' && item.entitlements !== '') {
		// TODO: NBA Feed only return entitlements : 'league-pass', 'league-pass-premium', 'nba-tv'
		// We do NOT know which program purchase it belong to
		// There are 4 Purchase: FREE(undefined), VAULT (1), PREMIUM (3), SUBSCRIBER (4))
		if (item.entitlements === 'leaguepass' || item.entitlements === 'league-pass') {
			program.purchaseTypeId = 4;
		} else if (item.entitlements === 'league-pass-premium') {
			program.purchaseTypeId = 3;
		} else if (item.entitlements === 'nbatv' || item.entitlements === 'nba-tv') {
			program.purchaseTypeId = 'nbatv';
		}
	}
	return program;
};

const processCustomPrograms = (items) => items.map((item) => (processCustomProgram(item)));

const processCustomDl = (item, isLarge) => {
	const dl = {};
	dl.id = item.id ? parseInt(item.id, 10) : null;
	dl.nbaId = item.nbaId ? parseInt(item.nbaId, 10) : null;
	dl.title = item.title;
	dl.subTitle = item.subTitle;
	dl.customImage = item.image ? `${item.image}?w=${isLarge ? '715' : '480'}&h=${isLarge ? '413' : '270'}` : '';
	dl.platform = item.platform;
	dl.style = item.style;
	dl.description = item.description;
	dl.link = item.link;
	dl.platform = item.platform;
	dl.program = processCustomProgram(item);
	return dl;
};

const processCustomDls = (items) => items.map(
		(item, index) => (processCustomDl(item, index === 0)),
);

const processCustomCategory = (item, isTVShows, curation) => {
	const category = {};
	category.id = parseInt(item.id, 10);
	category.name = item.name;
	category.description = item.description;
	if (typeof item.coverImage === 'string') {
		category.customImage = `${item.coverImage.customImage}?w=240&h=135`;
	} else if (typeof item.image === 'string') {
		category.customImage = `${item.image}?w=240&h=360`;
	} else if (typeof item.coverImage === 'object') {
		if (item.coverImage.landscape) {
			category.customImage = `${item.coverImage.landscape}?w=240&h=135`;
		} else {
			category.customImage = '';
		}
		if (item.coverImage.portrait) {
			category.bannerImage = `${item.coverImage.portrait}?w=240&h=135`;
		} else {
			category.bannerImage = '';
		}
	}
	category.seoName = item.seoName;
	if (isTVShows) {
		category.link = `/list/${item.curation || curation || 'nba-tv-series'}/${item.slug}`;
		if (item.slug) {
			category.customCatLink = `?plsrc=nba&${item.curation || curation || 'nba-tv-series'}=${item.slug}`;
		}
		if (item.latest) {
			category.latest = processCustomPrograms(item.latest);
			if (item.latest[0] && item.latest[0].nbatvSeason) {
				category.customCatLink = `${category.customCatLink}&season=${encodeURIComponent(item.latest[0].nbatvSeason)}`;
			}
		}
	} else {
		category.link = `/list/${item.curation || curation || 'category'}/${item.slug}`;
	}
	return category;
};

const processCustomCategories = (
		items,
		isTVShows = false,
		curation,
) => items.map((item) => (processCustomCategory(item, isTVShows, curation)));

const processCustomGame = (item) => {
	const game = {};
	if (item.type === 'game') {
		game.isGame = true;
		game.seoName = item.seoName;
		if (item.game) {
			game.gameId = item.game.id;
			game.gameState = item.game.state;
		}
	} else if (item.type === 'event') {
		game.isGame = false;
		game.seoName = item.seoName;
	}
	game.id = item.id ? parseInt(item.id, 10) : null;
	game.nbaId = item.nbaId ? parseInt(item.nbaId, 10) : null;
	game.name = item.title;
	if (item.gameTile && item.gameTile['428x241']) {
		game.customImage = item.gameTile['428x241'];
	} else if (item.image) {
		game.customImage = `${item.image}?w=480&h=270`;
	} else {
		game.customImage = '';
	}
	game.itemType = 'game';
	return game;
};

const processCustomGames = (games) => games.filter((item) => (item.type === 'game' || item.type === 'event' || item.type === 'video')).map((item) => (item.type === 'video' ? processCustomProgram(item) : processCustomGame(item)));

const processPageNav = (data) => {
	const menus = [];
	let menu;
	if (data.featured) {
		menu = {};
		menu.type = '8_dl';
		menu.name = data.featuredTitle;
		menu.data = processCustomDls(data.featured);
		menu.dataType = 'dl';
		menu.dataReady = true;
		menu.index = menus.length;
		menus[menus.length] = menu;
	}
	if (data.carousels && data.carousels.length > 0) {
		for (let i = 0; i < data.carousels.length; i += 1) {
			// Note: We only support video_carousel and taxonomy_cards
			const carousel = data.carousels[i];
			if (carousel.type === 'video_carousel' || carousel.type === 'taxonomy_cards' || carousel.type === 'collection_cards' || carousel.type === 'content_carousel') {
				menu = {};
				menu.index = menus.length;
				menu.name = carousel.title;
				let type = 'video';
				if (carousel.type === 'taxonomy_cards' || carousel.type === 'collection_cards') {
					type = 'categories';
				} else if (carousel.type === 'content_carousel') {
					type = 'content';
				}
				menu.dataType = type;
				menu.dataReady = true;
				if (carousel.value) {
					if (carousel.value.curation === 'feed') {
						if (carousel.value.slug === 'favorite_teams') {
							menu.type = '8_favteam';
						} else if (carousel.value.slug === 'game_schedule') {
							menu.type = '8_schedule';
							menu.dataType = 'game';
						} else {
							menu.type = carousel.value.slug;
						}
						if (carousel.value.slug && carousel.value.curation) {
							menu.moreLink = `/list/${carousel.value.curation}/${carousel.value.slug}`;
							menu.customCatLink = `?plsrc=es&feed=${carousel.value.slug}`;
						}
					} else {
						menu.type = carousel.value.layout === 'landscape' ? 'tv_shows' : carousel.type;
						if (carousel.type === 'taxonomy_cards' || carousel.type === 'collection_cards') {
							if (carousel.value.items) {
								menu.data = processCustomCategories(carousel.value.items, carousel.value.layout === 'landscape', carousel.value.curation);
							} else {
								menu.data = [];
							}
						} else if (carousel.type === 'content_carousel') {
							if (carousel.value.content) {
								menu.data = processCustomGames(carousel.value.content);
							} else {
								menu.data = [];
							}
						} else {
							if (carousel.value.videos) {
								menu.data = processCustomPrograms(carousel.value.videos);
							} else {
								menu.data = [];
							}
							if (carousel.value.slug && carousel.value.curation) {
								// Use '/{curation}/{slug}' as NBA Category detail page deep link
								menu.moreLink = `/list/${carousel.value.curation}/${carousel.value.slug}`;
								menu.customCatLink = `?plsrc=nba&${carousel.value.curation}=${carousel.value.slug}`;
							}
						}
					}
				}
				menus[menus.length] = menu;
			}
		}
	}
	return menus;
};

export {
	processPageNav,
	processCustomCategories,
	processCustomPrograms,
	processCustomNBAGameVideo,
	processCustomDls,
};
